"use client";

import { legacyIconCls } from "@faire/web/slate/utils/tracking";
import React from "react";

import { createSVGIcon } from "./util";

/**
 * @trackcomponent
 * @optimized using svgo:^3.0.2
 */
export const Bank = createSVGIcon(
  <path
    d="M4.382 34.005v-14m-1.75 14h8.75m-10.5 7h40.25m-40.25-3.5h40.25m-38.5-17.5h8.75m5.25 14h8.75m-8.75-14h8.75m-15.75 14v-14m8.75 14v-14m5.25 14v-14m7 14h8.75m-8.75-14h8.75m-7 14v-14m5.25 14v-14M2.887 14.94a.875.875 0 0 0 .538 1.567H38.6a.874.874 0 0 0 .54-1.565L21.6 1.178a.875.875 0 0 0-1.078 0z"
    stroke="#000"
    strokeLinecap="round"
    strokeLinejoin="round"
  />,
  "Bank",
  {
    viewBox: "0 0 42 42",
    titleAccess: "Bank",
    fill: "none",
    className: legacyIconCls(),
  }
);
